var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManagerMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.744922 4.21786C0.439682 4.11598 0.436758 3.95146 0.750769 3.84665L11.9119 0.121643C12.2212 0.018593 12.3984 0.191904 12.3119 0.495197L9.12265 11.6702C9.03494 11.98 8.85659 11.9905 8.72561 11.6966L6.62401 6.96097L10.1325 2.2769L5.45451 5.78995L0.744922 4.21786Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagerMessageIcon);
export default __webpack_public_path__ + "static/media/ManagerMessageIcon.de48416f64ee9a1b9fa75b6e6d46db72.svg";
export { ForwardRef as ReactComponent };